import React from 'react';
import { OverlayModalComponentProps } from '@sharefiledev/sharefile-appshell';
import { viewEnginePiletOverlays } from '@sharefiledev/view-engine-pilet-sdk';
import { BlockNames } from '../block.types';

const LazyViewByContainerRID = React.lazy(
	() => import('../components/ViewByContainerRID')
);

const defaultFallbackView = {
	blocks: [
		{
			blockRID: '',
			blockName: BlockNames.Text,
			blockParameters: {
				text: {
					en: 'View does not exist',
				},
			},
		},
	],
	rid: '',
	name: 'no-view',
	rootBlockRID: '',
};

export const ViewByContainerRIDDialog: React.FC<
	OverlayModalComponentProps<typeof viewEnginePiletOverlays.viewByContainerRIDDialog>
> = ({ piral, options, cancelInteraction, completeInteraction }) => {
	if (!options?.containerRID) {
		return <div data-testid="dialog-view-by-container-rid-error" />;
	}
	return (
		<React.Suspense fallback={<div data-testid="loading-dialog-view-by-container-rid" />}>
			<LazyViewByContainerRID
				containerRID={options.containerRID}
				cancelInteraction={cancelInteraction}
				completeInteraction={completeInteraction}
				piletApi={piral}
				fallbackView={options.fallbackView ?? defaultFallbackView}
				contractData={options.contractData}
			/>
		</React.Suspense>
	);
};
